import React from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core';
import {
  Card,
  CardContent,
  Grid,
  Typography,
  CircularProgress,
  Avatar,
  colors
} from '@material-ui/core';
import { Storage } from '@material-ui/icons';

const styles = theme => ({
  root: {
    height: '100%',

  },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: {
    fontWeight: 700
  },
  avatar: {
    backgroundColor: theme.palette.error.dark,
    color: theme.palette.buttonText.default,
    height: 56,
    width: 56
  },
  icon: {
    height: 32,
    width: 32
  },
  progress: {
    marginTop: theme.spacing(3)
  },
  typography: {
    color: colors.blueGrey[900],
    fontWeight: 500,
    fontSize: '20px',
    letterSpacing: '-0.06px',
    lineHeight: '24px'
  }
});

const NotErasedStorages = props => {
  const { className, classes, loading, numberOfStorages, ...rest } = props;


  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
        >
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              {props.translations['failed_to_erase'] || "FAILED TO ERASE "}
            </Typography>
            {loading ? <CircularProgress size={20} /> : <Typography className={classes.typography}> {numberOfStorages} </Typography>}
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <Storage className={classes.icon} />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};



export default withStyles(styles, { withTheme: true })(NotErasedStorages);
